import * as o from "react";
import { useLayoutEffect as Je, useEffect as et, useRef as tt } from "react";
import { isTypeableCombobox as nt, getDocument as U, activeElement as G, contains as X, isVirtualClick as rt, isVirtualPointerEvent as qe, getPlatform as ot, isMouseLikePointerType as de, isSafari as Xe, stopEvent as be, getTarget as z, isTypeableElement as Ye, isReactEvent as st, isRootElement as ut, isEventTargetWithin as ge, isMac as ct } from "./atoms-v2781.js";
import { useFloating as it } from "./atoms-v2719.js";
import { arrow as rn } from "./atoms-v2719.js";
import { isHTMLElement as ce, isElement as Y, getOverflowAncestors as Ee, getNodeName as lt, isLastTraversableNode as Fe, getParentNode as at, getComputedStyle as ft, getWindow as dt } from "./atoms-v2782.js";
import { tabbable as pe, isTabbable as mt } from "./atoms-v2783.js";
import { createPortal as pt } from "react-dom";
import { platform as vt } from "./atoms-v283.js";
import { autoUpdate as sn, computePosition as un, flip as cn, inline as ln, shift as an, size as fn } from "./atoms-v283.js";
function qt(e) {
  return o.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    e.forEach((t) => {
      typeof t == "function" ? t(r) : t != null && (t.current = r);
    });
  }, e);
}
const bt = o.useInsertionEffect, gt = bt || ((e) => e());
function te(e) {
  const r = o.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return gt(() => {
    r.current = e;
  }), o.useCallback(function() {
    for (var t = arguments.length, n = new Array(t), l = 0; l < t; l++)
      n[l] = arguments[l];
    return r.current == null ? void 0 : r.current(...n);
  }, []);
}
let Me = 0;
function Q(e, r) {
  r === void 0 && (r = {});
  const {
    preventScroll: t = !1,
    cancelPrevious: n = !0,
    sync: l = !1
  } = r;
  n && cancelAnimationFrame(Me);
  const s = () => e == null ? void 0 : e.focus({
    preventScroll: t
  });
  l ? s() : Me = requestAnimationFrame(s);
}
var $ = typeof document < "u" ? Je : et;
function ne() {
  return ne = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, ne.apply(this, arguments);
}
let he = !1, Et = 0;
const Le = () => "floating-ui-" + Et++;
function ht() {
  const [e, r] = o.useState(() => he ? Le() : void 0);
  return $(() => {
    e == null && r(Le());
  }, []), o.useEffect(() => {
    he || (he = !0);
  }, []), e;
}
const yt = o.useId, le = yt || ht, Xt = /* @__PURE__ */ o.forwardRef(function(r, t) {
  let {
    context: {
      placement: n,
      elements: {
        floating: l
      },
      middlewareData: {
        arrow: s
      }
    },
    width: c = 14,
    height: i = 7,
    tipRadius: m = 0,
    strokeWidth: a = 0,
    staticOffset: E,
    stroke: g,
    d: f,
    style: {
      transform: u,
      ...b
    } = {},
    ...h
  } = r;
  process.env.NODE_ENV !== "production" && (t || console.warn("Floating UI: The `ref` prop is required for the `FloatingArrow`", "component."));
  const D = le();
  if (!l)
    return null;
  a *= 2;
  const R = a / 2, p = c / 2 * (m / -8 + 1), W = i / 2 * m / 4, [F, A] = n.split("-"), L = vt.isRTL(l), K = !!f, C = F === "top" || F === "bottom", I = E && A === "end" ? "bottom" : "top";
  let y = E && A === "end" ? "right" : "left";
  E && L && (y = A === "end" ? "left" : "right");
  const H = (s == null ? void 0 : s.x) != null ? E || s.x : "", q = (s == null ? void 0 : s.y) != null ? E || s.y : "", N = f || // biome-ignore lint/style/useTemplate: readability
  "M0,0" + (" H" + c) + (" L" + (c - p) + "," + (i - W)) + (" Q" + c / 2 + "," + i + " " + p + "," + (i - W)) + " Z", O = {
    top: K ? "rotate(180deg)" : "",
    left: K ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: K ? "" : "rotate(180deg)",
    right: K ? "rotate(-90deg)" : "rotate(90deg)"
  }[F];
  return /* @__PURE__ */ o.createElement("svg", ne({}, h, {
    "aria-hidden": !0,
    ref: t,
    width: K ? c : c + a,
    height: c,
    viewBox: "0 0 " + c + " " + (i > c ? i : c),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [y]: H,
      [I]: q,
      [F]: C || K ? "100%" : "calc(100% - " + a / 2 + "px)",
      transform: "" + O + (u ?? ""),
      ...b
    }
  }), a > 0 && /* @__PURE__ */ o.createElement("path", {
    clipPath: "url(#" + D + ")",
    fill: "none",
    stroke: g,
    strokeWidth: a + (f ? 0 : 1),
    d: N
  }), /* @__PURE__ */ o.createElement("path", {
    stroke: a && !f ? h.fill : "none",
    d: N
  }), /* @__PURE__ */ o.createElement("clipPath", {
    id: D
  }, /* @__PURE__ */ o.createElement("rect", {
    x: -R,
    y: R * (K ? -1 : 1),
    width: c + a,
    height: c
  })));
});
function Rt() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(r, t) {
      var n;
      (n = e.get(r)) == null || n.forEach((l) => l(t));
    },
    on(r, t) {
      e.set(r, [...e.get(r) || [], t]);
    },
    off(r, t) {
      var n;
      e.set(r, ((n = e.get(r)) == null ? void 0 : n.filter((l) => l !== t)) || []);
    }
  };
}
const wt = /* @__PURE__ */ o.createContext(null), xt = /* @__PURE__ */ o.createContext(null), ke = () => {
  var e;
  return ((e = o.useContext(wt)) == null ? void 0 : e.id) || null;
}, ve = () => o.useContext(xt);
function J(e) {
  return "data-floating-ui-" + e;
}
function oe(e) {
  const r = tt(e);
  return $(() => {
    r.current = e;
  }), r;
}
const Ie = /* @__PURE__ */ J("safe-polygon");
function ye(e, r, t) {
  return t && !de(t) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[r];
}
function Yt(e, r) {
  r === void 0 && (r = {});
  const {
    open: t,
    onOpenChange: n,
    dataRef: l,
    events: s,
    elements: {
      domReference: c,
      floating: i
    },
    refs: m
  } = e, {
    enabled: a = !0,
    delay: E = 0,
    handleClose: g = null,
    mouseOnly: f = !1,
    restMs: u = 0,
    move: b = !0
  } = r, h = ve(), D = ke(), R = oe(g), p = oe(E), W = o.useRef(), F = o.useRef(), A = o.useRef(), L = o.useRef(), K = o.useRef(!0), C = o.useRef(!1), I = o.useRef(() => {
  }), y = o.useCallback(() => {
    var O;
    const v = (O = l.current.openEvent) == null ? void 0 : O.type;
    return (v == null ? void 0 : v.includes("mouse")) && v !== "mousedown";
  }, [l]);
  o.useEffect(() => {
    if (!a)
      return;
    function O(v) {
      let {
        open: w
      } = v;
      w || (clearTimeout(F.current), clearTimeout(L.current), K.current = !0);
    }
    return s.on("openchange", O), () => {
      s.off("openchange", O);
    };
  }, [a, s]), o.useEffect(() => {
    if (!a || !R.current || !t)
      return;
    function O(w) {
      y() && n(!1, w, "hover");
    }
    const v = U(i).documentElement;
    return v.addEventListener("mouseleave", O), () => {
      v.removeEventListener("mouseleave", O);
    };
  }, [i, t, n, a, R, y]);
  const H = o.useCallback(function(O, v, w) {
    v === void 0 && (v = !0), w === void 0 && (w = "hover");
    const x = ye(p.current, "close", W.current);
    x && !A.current ? (clearTimeout(F.current), F.current = setTimeout(() => n(!1, O, w), x)) : v && (clearTimeout(F.current), n(!1, O, w));
  }, [p, n]), q = o.useCallback(() => {
    I.current(), A.current = void 0;
  }, []), N = o.useCallback(() => {
    if (C.current) {
      const O = U(m.floating.current).body;
      O.style.pointerEvents = "", O.removeAttribute(Ie), C.current = !1;
    }
  }, [m]);
  return o.useEffect(() => {
    if (!a)
      return;
    function O() {
      return l.current.openEvent ? ["click", "mousedown"].includes(l.current.openEvent.type) : !1;
    }
    function v(d) {
      if (clearTimeout(F.current), K.current = !1, f && !de(W.current) || u > 0 && ye(p.current, "open") === 0)
        return;
      const V = ye(p.current, "open", W.current);
      V ? F.current = setTimeout(() => {
        n(!0, d, "hover");
      }, V) : n(!0, d, "hover");
    }
    function w(d) {
      if (O())
        return;
      I.current();
      const V = U(i);
      if (clearTimeout(L.current), R.current) {
        t || clearTimeout(F.current), A.current = R.current({
          ...e,
          tree: h,
          x: d.clientX,
          y: d.clientY,
          onClose() {
            N(), q(), H(d, !0, "safe-polygon");
          }
        });
        const T = A.current;
        V.addEventListener("mousemove", T), I.current = () => {
          V.removeEventListener("mousemove", T);
        };
        return;
      }
      (W.current === "touch" ? !X(i, d.relatedTarget) : !0) && H(d);
    }
    function x(d) {
      O() || R.current == null || R.current({
        ...e,
        tree: h,
        x: d.clientX,
        y: d.clientY,
        onClose() {
          N(), q(), H(d);
        }
      })(d);
    }
    if (Y(c)) {
      const d = c;
      return t && d.addEventListener("mouseleave", x), i == null || i.addEventListener("mouseleave", x), b && d.addEventListener("mousemove", v, {
        once: !0
      }), d.addEventListener("mouseenter", v), d.addEventListener("mouseleave", w), () => {
        t && d.removeEventListener("mouseleave", x), i == null || i.removeEventListener("mouseleave", x), b && d.removeEventListener("mousemove", v), d.removeEventListener("mouseenter", v), d.removeEventListener("mouseleave", w);
      };
    }
  }, [c, i, a, e, f, u, b, H, q, N, n, t, h, p, R, l]), $(() => {
    var O;
    if (a && t && (O = R.current) != null && O.__options.blockPointerEvents && y()) {
      const w = U(i).body;
      if (w.setAttribute(Ie, ""), w.style.pointerEvents = "none", C.current = !0, Y(c) && i) {
        var v;
        const x = c, d = h == null || (v = h.nodesRef.current.find((V) => V.id === D)) == null || (v = v.context) == null ? void 0 : v.elements.floating;
        return d && (d.style.pointerEvents = ""), x.style.pointerEvents = "auto", i.style.pointerEvents = "auto", () => {
          x.style.pointerEvents = "", i.style.pointerEvents = "";
        };
      }
    }
  }, [a, t, D, i, c, h, R, y]), $(() => {
    t || (W.current = void 0, q(), N());
  }, [t, q, N]), o.useEffect(() => () => {
    q(), clearTimeout(F.current), clearTimeout(L.current), N();
  }, [a, c, q, N]), o.useMemo(() => {
    if (!a)
      return {};
    function O(v) {
      W.current = v.pointerType;
    }
    return {
      reference: {
        onPointerDown: O,
        onPointerEnter: O,
        onMouseMove(v) {
          t || u === 0 || (clearTimeout(L.current), L.current = setTimeout(() => {
            K.current || n(!0, v.nativeEvent, "hover");
          }, u));
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(F.current);
        },
        onMouseLeave(v) {
          H(v.nativeEvent, !1);
        }
      }
    };
  }, [a, u, t, n, H]);
}
function Tt(e, r) {
  var t;
  let n = [], l = (t = e.find((s) => s.id === r)) == null ? void 0 : t.parentId;
  for (; l; ) {
    const s = e.find((c) => c.id === l);
    l = s == null ? void 0 : s.parentId, s && (n = n.concat(s));
  }
  return n;
}
function se(e, r) {
  let t = e.filter((l) => {
    var s;
    return l.parentId === r && ((s = l.context) == null ? void 0 : s.open);
  }), n = t;
  for (; n.length; )
    n = e.filter((l) => {
      var s;
      return (s = n) == null ? void 0 : s.some((c) => {
        var i;
        return l.parentId === c.id && ((i = l.context) == null ? void 0 : i.open);
      });
    }), t = t.concat(n);
  return t;
}
let ee = /* @__PURE__ */ new WeakMap(), ae = /* @__PURE__ */ new WeakSet(), fe = {}, Re = 0;
const Ct = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, Ue = (e) => e && (e.host || Ue(e.parentNode)), kt = (e, r) => r.map((t) => {
  if (e.contains(t))
    return t;
  const n = Ue(t);
  return e.contains(n) ? n : null;
}).filter((t) => t != null);
function Ot(e, r, t, n) {
  const l = "data-floating-ui-inert", s = n ? "inert" : t ? "aria-hidden" : null, c = kt(r, e), i = /* @__PURE__ */ new Set(), m = new Set(c), a = [];
  fe[l] || (fe[l] = /* @__PURE__ */ new WeakMap());
  const E = fe[l];
  c.forEach(g), f(r), i.clear();
  function g(u) {
    !u || i.has(u) || (i.add(u), u.parentNode && g(u.parentNode));
  }
  function f(u) {
    !u || m.has(u) || Array.prototype.forEach.call(u.children, (b) => {
      if (i.has(b))
        f(b);
      else {
        const h = s ? b.getAttribute(s) : null, D = h !== null && h !== "false", R = (ee.get(b) || 0) + 1, p = (E.get(b) || 0) + 1;
        ee.set(b, R), E.set(b, p), a.push(b), R === 1 && D && ae.add(b), p === 1 && b.setAttribute(l, ""), !D && s && b.setAttribute(s, "true");
      }
    });
  }
  return Re++, () => {
    a.forEach((u) => {
      const b = (ee.get(u) || 0) - 1, h = (E.get(u) || 0) - 1;
      ee.set(u, b), E.set(u, h), b || (!ae.has(u) && s && u.removeAttribute(s), ae.delete(u)), h || u.removeAttribute(l);
    }), Re--, Re || (ee = /* @__PURE__ */ new WeakMap(), ee = /* @__PURE__ */ new WeakMap(), ae = /* @__PURE__ */ new WeakSet(), fe = {});
  };
}
function Se(e, r, t) {
  r === void 0 && (r = !1), t === void 0 && (t = !1);
  const n = U(e[0]).body;
  return Ot(e.concat(Array.from(n.querySelectorAll("[aria-live]"))), n, r, t);
}
const ie = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function $e(e, r) {
  const t = pe(e, ie());
  r === "prev" && t.reverse();
  const n = t.indexOf(G(U(e)));
  return t.slice(n + 1)[0];
}
function je() {
  return $e(document.body, "next");
}
function Ge() {
  return $e(document.body, "prev");
}
function ue(e, r) {
  const t = r || e.currentTarget, n = e.relatedTarget;
  return !n || !X(t, n);
}
function Pt(e) {
  pe(e, ie()).forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  });
}
function Ft(e) {
  e.querySelectorAll("[data-tabindex]").forEach((t) => {
    const n = t.dataset.tabindex;
    delete t.dataset.tabindex, n ? t.setAttribute("tabindex", n) : t.removeAttribute("tabindex");
  });
}
const Oe = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let Mt;
function De(e) {
  e.key === "Tab" && (e.target, clearTimeout(Mt));
}
const me = /* @__PURE__ */ o.forwardRef(function(r, t) {
  const [n, l] = o.useState();
  $(() => (Xe() && l("button"), document.addEventListener("keydown", De), () => {
    document.removeEventListener("keydown", De);
  }), []);
  const s = {
    ref: t,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: n,
    "aria-hidden": n ? void 0 : !0,
    [J("focus-guard")]: "",
    style: Oe
  };
  return /* @__PURE__ */ o.createElement("span", ne({}, r, s));
}), Qe = /* @__PURE__ */ o.createContext(null), Ae = /* @__PURE__ */ J("portal");
function Lt(e) {
  let {
    id: r,
    root: t
  } = e === void 0 ? {} : e;
  const [n, l] = o.useState(null), s = le(), c = Ze(), i = o.useRef(null);
  return $(() => () => {
    n == null || n.remove(), queueMicrotask(() => {
      i.current = null;
    });
  }, [n]), $(() => {
    if (i.current)
      return;
    const m = r ? document.getElementById(r) : null;
    if (!m)
      return;
    const a = document.createElement("div");
    a.id = s, a.setAttribute(Ae, ""), m.appendChild(a), i.current = a, l(a);
  }, [r, s]), $(() => {
    if (i.current)
      return;
    let m = t || (c == null ? void 0 : c.portalNode);
    m && !Y(m) && (m = m.current), m = m || document.body;
    let a = null;
    r && (a = document.createElement("div"), a.id = r, m.appendChild(a));
    const E = document.createElement("div");
    E.id = s, E.setAttribute(Ae, ""), m = a || m, m.appendChild(E), i.current = E, l(E);
  }, [r, t, s, c]), n;
}
function Ut(e) {
  let {
    children: r,
    id: t,
    root: n = null,
    preserveTabOrder: l = !0
  } = e;
  const s = Lt({
    id: t,
    root: n
  }), [c, i] = o.useState(null), m = o.useRef(null), a = o.useRef(null), E = o.useRef(null), g = o.useRef(null), f = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!c && // Guards are only for non-modal focus management.
    !c.modal && // Don't render if unmount is transitioning.
    c.open && l && !!(n || s)
  );
  return o.useEffect(() => {
    if (!s || !l || c != null && c.modal)
      return;
    function u(b) {
      s && ue(b) && (b.type === "focusin" ? Ft : Pt)(s);
    }
    return s.addEventListener("focusin", u, !0), s.addEventListener("focusout", u, !0), () => {
      s.removeEventListener("focusin", u, !0), s.removeEventListener("focusout", u, !0);
    };
  }, [s, l, c == null ? void 0 : c.modal]), /* @__PURE__ */ o.createElement(Qe.Provider, {
    value: o.useMemo(() => ({
      preserveTabOrder: l,
      beforeOutsideRef: m,
      afterOutsideRef: a,
      beforeInsideRef: E,
      afterInsideRef: g,
      portalNode: s,
      setFocusManagerState: i
    }), [l, s])
  }, f && s && /* @__PURE__ */ o.createElement(me, {
    "data-type": "outside",
    ref: m,
    onFocus: (u) => {
      if (ue(u, s)) {
        var b;
        (b = E.current) == null || b.focus();
      } else {
        const h = Ge() || (c == null ? void 0 : c.refs.domReference.current);
        h == null || h.focus();
      }
    }
  }), f && s && /* @__PURE__ */ o.createElement("span", {
    "aria-owns": s.id,
    style: Oe
  }), s && /* @__PURE__ */ pt(r, s), f && s && /* @__PURE__ */ o.createElement(me, {
    "data-type": "outside",
    ref: a,
    onFocus: (u) => {
      if (ue(u, s)) {
        var b;
        (b = g.current) == null || b.focus();
      } else {
        const h = je() || (c == null ? void 0 : c.refs.domReference.current);
        h == null || h.focus(), c != null && c.closeOnFocusOut && (c == null || c.onOpenChange(!1, u.nativeEvent));
      }
    }
  }));
}
const Ze = () => o.useContext(Qe), Ne = 20;
let Z = [];
function we(e) {
  Z = Z.filter((t) => t.isConnected);
  let r = e;
  if (!(!r || lt(r) === "body")) {
    if (!mt(r, ie())) {
      const t = pe(r, ie())[0];
      if (!t)
        return;
      r = t;
    }
    Z.push(r), Z.length > Ne && (Z = Z.slice(-Ne));
  }
}
function _e() {
  return Z.slice().reverse().find((e) => e.isConnected);
}
const It = /* @__PURE__ */ o.forwardRef(function(r, t) {
  return /* @__PURE__ */ o.createElement("button", ne({}, r, {
    type: "button",
    ref: t,
    tabIndex: -1,
    style: Oe
  }));
});
function $t(e) {
  const {
    context: r,
    children: t,
    disabled: n = !1,
    order: l = ["content"],
    guards: s = !0,
    initialFocus: c = 0,
    returnFocus: i = !0,
    modal: m = !0,
    visuallyHiddenDismiss: a = !1,
    closeOnFocusOut: E = !0
  } = e, {
    open: g,
    refs: f,
    nodeId: u,
    onOpenChange: b,
    events: h,
    dataRef: D,
    elements: {
      domReference: R,
      floating: p
    }
  } = r, W = typeof c == "number" && c < 0, F = nt(R) && W, A = Ct() ? s : !0, L = oe(l), K = oe(c), C = oe(i), I = ve(), y = Ze(), H = o.useRef(null), q = o.useRef(null), N = o.useRef(!1), O = o.useRef(!1), v = y != null, w = o.useCallback(function(P) {
    return P === void 0 && (P = p), P ? pe(P, ie()) : [];
  }, [p]), x = o.useCallback((P) => {
    const T = w(P);
    return L.current.map((k) => R && k === "reference" ? R : p && k === "floating" ? p : T).filter(Boolean).flat();
  }, [R, p, L, w]);
  o.useEffect(() => {
    if (n || !m)
      return;
    function P(k) {
      if (k.key === "Tab") {
        X(p, G(U(p))) && w().length === 0 && !F && be(k);
        const M = x(), S = z(k);
        L.current[0] === "reference" && S === R && (be(k), k.shiftKey ? Q(M[M.length - 1]) : Q(M[1])), L.current[1] === "floating" && S === p && k.shiftKey && (be(k), Q(M[0]));
      }
    }
    const T = U(p);
    return T.addEventListener("keydown", P), () => {
      T.removeEventListener("keydown", P);
    };
  }, [n, R, p, m, L, F, w, x]), o.useEffect(() => {
    if (n || !E)
      return;
    function P() {
      O.current = !0, setTimeout(() => {
        O.current = !1;
      });
    }
    function T(k) {
      const M = k.relatedTarget;
      queueMicrotask(() => {
        const S = !(X(R, M) || X(p, M) || X(M, p) || X(y == null ? void 0 : y.portalNode, M) || M != null && M.hasAttribute(J("focus-guard")) || I && (se(I.nodesRef.current, u).find((_) => {
          var B, j;
          return X((B = _.context) == null ? void 0 : B.elements.floating, M) || X((j = _.context) == null ? void 0 : j.elements.domReference, M);
        }) || Tt(I.nodesRef.current, u).find((_) => {
          var B, j;
          return ((B = _.context) == null ? void 0 : B.elements.floating) === M || ((j = _.context) == null ? void 0 : j.elements.domReference) === M;
        })));
        M && S && !O.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        M !== _e() && (N.current = !0, b(!1, k));
      });
    }
    if (p && ce(R))
      return R.addEventListener("focusout", T), R.addEventListener("pointerdown", P), !m && p.addEventListener("focusout", T), () => {
        R.removeEventListener("focusout", T), R.removeEventListener("pointerdown", P), !m && p.removeEventListener("focusout", T);
      };
  }, [n, R, p, m, u, I, y, b, E]), o.useEffect(() => {
    var P;
    if (n)
      return;
    const T = Array.from((y == null || (P = y.portalNode) == null ? void 0 : P.querySelectorAll("[" + J("portal") + "]")) || []);
    if (p) {
      const k = [p, ...T, H.current, q.current, L.current.includes("reference") || F ? R : null].filter((S) => S != null), M = m || F ? Se(k, A, !A) : Se(k);
      return () => {
        M();
      };
    }
  }, [n, R, p, m, L, y, F, A]), $(() => {
    if (n || !p)
      return;
    const P = U(p), T = G(P);
    queueMicrotask(() => {
      const k = x(p), M = K.current, S = (typeof M == "number" ? k[M] : M.current) || p, _ = X(p, T);
      !W && !_ && g && Q(S, {
        preventScroll: S === p
      });
    });
  }, [n, g, p, W, x, K]), $(() => {
    if (n || !p)
      return;
    let P = !1;
    const T = U(p), k = G(T), M = D.current;
    we(k);
    function S(_) {
      let {
        reason: B,
        event: j,
        nested: re
      } = _;
      B === "escape-key" && f.domReference.current && we(f.domReference.current), B === "hover" && j.type === "mouseleave" && (N.current = !0), B === "outside-press" && (re ? (N.current = !1, P = !0) : N.current = !(rt(j) || qe(j)));
    }
    return h.on("openchange", S), () => {
      h.off("openchange", S);
      const _ = G(T), B = X(p, _) || I && se(I.nodesRef.current, u).some((ze) => {
        var Pe;
        return X((Pe = ze.context) == null ? void 0 : Pe.elements.floating, _);
      });
      (B || M.openEvent && ["click", "mousedown"].includes(M.openEvent.type)) && f.domReference.current && we(f.domReference.current);
      const re = _e();
      C.current && !N.current && ce(re) && // If the focus moved somewhere else after mount, avoid returning focus
      // since it likely entered a different element which should be
      // respected: https://github.com/floating-ui/floating-ui/issues/2607
      (!(re !== _ && _ !== T.body) || B) && Q(re, {
        // When dismissing nested floating elements, by the time the rAF has
        // executed, the menus will all have been unmounted. When they try
        // to get focused, the calls get ignored — leaving the root
        // reference focused as desired.
        cancelPrevious: !1,
        preventScroll: P
      });
    };
  }, [n, p, C, D, f, h, I, u]), $(() => {
    if (!(n || !y))
      return y.setFocusManagerState({
        modal: m,
        closeOnFocusOut: E,
        open: g,
        onOpenChange: b,
        refs: f
      }), () => {
        y.setFocusManagerState(null);
      };
  }, [n, y, m, g, b, f, E]), $(() => {
    if (n || !p || typeof MutationObserver != "function" || W)
      return;
    const P = () => {
      const k = p.getAttribute("tabindex");
      L.current.includes("floating") || G(U(p)) !== f.domReference.current && w().length === 0 ? k !== "0" && p.setAttribute("tabindex", "0") : k !== "-1" && p.setAttribute("tabindex", "-1");
    };
    P();
    const T = new MutationObserver(P);
    return T.observe(p, {
      childList: !0,
      subtree: !0,
      attributes: !0
    }), () => {
      T.disconnect();
    };
  }, [n, p, f, L, w, W]);
  function d(P) {
    return n || !a || !m ? null : /* @__PURE__ */ o.createElement(It, {
      ref: P === "start" ? H : q,
      onClick: (T) => b(!1, T.nativeEvent)
    }, typeof a == "string" ? a : "Dismiss");
  }
  const V = !n && A && (v || m);
  return /* @__PURE__ */ o.createElement(o.Fragment, null, V && /* @__PURE__ */ o.createElement(me, {
    "data-type": "inside",
    ref: y == null ? void 0 : y.beforeInsideRef,
    onFocus: (P) => {
      if (m) {
        const k = x();
        Q(l[0] === "reference" ? k[0] : k[k.length - 1]);
      } else if (y != null && y.preserveTabOrder && y.portalNode)
        if (N.current = !1, ue(P, y.portalNode)) {
          const k = je() || R;
          k == null || k.focus();
        } else {
          var T;
          (T = y.beforeOutsideRef.current) == null || T.focus();
        }
    }
  }), !F && d("start"), t, d("end"), V && /* @__PURE__ */ o.createElement(me, {
    "data-type": "inside",
    ref: y == null ? void 0 : y.afterInsideRef,
    onFocus: (P) => {
      if (m)
        Q(x()[0]);
      else if (y != null && y.preserveTabOrder && y.portalNode)
        if (E && (N.current = !0), ue(P, y.portalNode)) {
          const k = Ge() || R;
          k == null || k.focus();
        } else {
          var T;
          (T = y.afterOutsideRef.current) == null || T.focus();
        }
    }
  }));
}
const xe = /* @__PURE__ */ new Set(), jt = /* @__PURE__ */ o.forwardRef(function(r, t) {
  let {
    lockScroll: n = !1,
    ...l
  } = r;
  const s = le();
  return $(() => {
    if (!n)
      return;
    xe.add(s);
    const c = /iP(hone|ad|od)|iOS/.test(ot()), i = document.body.style, a = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft ? "paddingLeft" : "paddingRight", E = window.innerWidth - document.documentElement.clientWidth, g = i.left ? parseFloat(i.left) : window.pageXOffset, f = i.top ? parseFloat(i.top) : window.pageYOffset;
    if (i.overflow = "hidden", E && (i[a] = E + "px"), c) {
      var u, b;
      const h = ((u = window.visualViewport) == null ? void 0 : u.offsetLeft) || 0, D = ((b = window.visualViewport) == null ? void 0 : b.offsetTop) || 0;
      Object.assign(i, {
        position: "fixed",
        top: -(f - Math.floor(D)) + "px",
        left: -(g - Math.floor(h)) + "px",
        right: "0"
      });
    }
    return () => {
      xe.delete(s), xe.size === 0 && (Object.assign(i, {
        overflow: "",
        [a]: ""
      }), c && (Object.assign(i, {
        position: "",
        top: "",
        left: "",
        right: ""
      }), window.scrollTo(g, f)));
    };
  }, [s, n]), /* @__PURE__ */ o.createElement("div", ne({
    ref: t
  }, l, {
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...l.style
    }
  }));
});
function Ke(e) {
  return ce(e.target) && e.target.tagName === "BUTTON";
}
function We(e) {
  return Ye(e);
}
function Gt(e, r) {
  r === void 0 && (r = {});
  const {
    open: t,
    onOpenChange: n,
    dataRef: l,
    elements: {
      domReference: s
    }
  } = e, {
    enabled: c = !0,
    event: i = "click",
    toggle: m = !0,
    ignoreMouse: a = !1,
    keyboardHandlers: E = !0
  } = r, g = o.useRef(), f = o.useRef(!1);
  return o.useMemo(() => c ? {
    reference: {
      onPointerDown(u) {
        g.current = u.pointerType;
      },
      onMouseDown(u) {
        u.button === 0 && (de(g.current, !0) && a || i !== "click" && (t && m && (!l.current.openEvent || l.current.openEvent.type === "mousedown") ? n(!1, u.nativeEvent, "click") : (u.preventDefault(), n(!0, u.nativeEvent, "click"))));
      },
      onClick(u) {
        if (i === "mousedown" && g.current) {
          g.current = void 0;
          return;
        }
        de(g.current, !0) && a || (t && m && (!l.current.openEvent || l.current.openEvent.type === "click") ? n(!1, u.nativeEvent, "click") : n(!0, u.nativeEvent, "click"));
      },
      onKeyDown(u) {
        g.current = void 0, !(u.defaultPrevented || !E || Ke(u)) && (u.key === " " && !We(s) && (u.preventDefault(), f.current = !0), u.key === "Enter" && n(!(t && m), u.nativeEvent, "click"));
      },
      onKeyUp(u) {
        u.defaultPrevented || !E || Ke(u) || We(s) || u.key === " " && f.current && (f.current = !1, n(!(t && m), u.nativeEvent, "click"));
      }
    }
  } : {}, [c, l, i, a, E, s, m, t, n]);
}
const St = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, Dt = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, He = (e) => {
  var r, t;
  return {
    escapeKey: typeof e == "boolean" ? e : (r = e == null ? void 0 : e.escapeKey) != null ? r : !1,
    outsidePress: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.outsidePress) != null ? t : !0
  };
};
function Qt(e, r) {
  r === void 0 && (r = {});
  const {
    open: t,
    onOpenChange: n,
    nodeId: l,
    elements: {
      reference: s,
      domReference: c,
      floating: i
    },
    dataRef: m
  } = e, {
    enabled: a = !0,
    escapeKey: E = !0,
    outsidePress: g = !0,
    outsidePressEvent: f = "pointerdown",
    referencePress: u = !1,
    referencePressEvent: b = "pointerdown",
    ancestorScroll: h = !1,
    bubbles: D,
    capture: R
  } = r, p = ve(), W = te(typeof g == "function" ? g : () => !1), F = typeof g == "function" ? W : g, A = o.useRef(!1), L = o.useRef(!1), {
    escapeKey: K,
    outsidePress: C
  } = He(D), {
    escapeKey: I,
    outsidePress: y
  } = He(R), H = te((v) => {
    if (!t || !a || !E || v.key !== "Escape")
      return;
    const w = p ? se(p.nodesRef.current, l) : [];
    if (!K && (v.stopPropagation(), w.length > 0)) {
      let x = !0;
      if (w.forEach((d) => {
        var V;
        if ((V = d.context) != null && V.open && !d.context.dataRef.current.__escapeKeyBubbles) {
          x = !1;
          return;
        }
      }), !x)
        return;
    }
    n(!1, st(v) ? v.nativeEvent : v, "escape-key");
  }), q = te((v) => {
    var w;
    const x = () => {
      var d;
      H(v), (d = z(v)) == null || d.removeEventListener("keydown", x);
    };
    (w = z(v)) == null || w.addEventListener("keydown", x);
  }), N = te((v) => {
    const w = A.current;
    A.current = !1;
    const x = L.current;
    if (L.current = !1, f === "click" && x || w || typeof F == "function" && !F(v))
      return;
    const d = z(v), V = "[" + J("inert") + "]", P = U(i).querySelectorAll(V);
    let T = Y(d) ? d : null;
    for (; T && !Fe(T); ) {
      const S = at(T);
      if (Fe(S) || !Y(S))
        break;
      T = S;
    }
    if (P.length && Y(d) && !ut(d) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !X(d, i) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(P).every((S) => !X(T, S)))
      return;
    if (ce(d) && i) {
      const S = d.clientWidth > 0 && d.scrollWidth > d.clientWidth, _ = d.clientHeight > 0 && d.scrollHeight > d.clientHeight;
      let B = _ && v.offsetX > d.clientWidth;
      if (_ && ft(d).direction === "rtl" && (B = v.offsetX <= d.offsetWidth - d.clientWidth), B || S && v.offsetY > d.clientHeight)
        return;
    }
    const k = p && se(p.nodesRef.current, l).some((S) => {
      var _;
      return ge(v, (_ = S.context) == null ? void 0 : _.elements.floating);
    });
    if (ge(v, i) || ge(v, c) || k)
      return;
    const M = p ? se(p.nodesRef.current, l) : [];
    if (M.length > 0) {
      let S = !0;
      if (M.forEach((_) => {
        var B;
        if ((B = _.context) != null && B.open && !_.context.dataRef.current.__outsidePressBubbles) {
          S = !1;
          return;
        }
      }), !S)
        return;
    }
    n(!1, v, "outside-press");
  }), O = te((v) => {
    var w;
    const x = () => {
      var d;
      N(v), (d = z(v)) == null || d.removeEventListener(f, x);
    };
    (w = z(v)) == null || w.addEventListener(f, x);
  });
  return o.useEffect(() => {
    if (!t || !a)
      return;
    m.current.__escapeKeyBubbles = K, m.current.__outsidePressBubbles = C;
    function v(d) {
      n(!1, d, "ancestor-scroll");
    }
    const w = U(i);
    E && w.addEventListener("keydown", I ? q : H, I), F && w.addEventListener(f, y ? O : N, y);
    let x = [];
    return h && (Y(c) && (x = Ee(c)), Y(i) && (x = x.concat(Ee(i))), !Y(s) && s && s.contextElement && (x = x.concat(Ee(s.contextElement)))), x = x.filter((d) => {
      var V;
      return d !== ((V = w.defaultView) == null ? void 0 : V.visualViewport);
    }), x.forEach((d) => {
      d.addEventListener("scroll", v, {
        passive: !0
      });
    }), () => {
      E && w.removeEventListener("keydown", I ? q : H, I), F && w.removeEventListener(f, y ? O : N, y), x.forEach((d) => {
        d.removeEventListener("scroll", v);
      });
    };
  }, [m, i, c, s, E, F, f, t, n, h, a, K, C, H, I, q, N, y, O]), o.useEffect(() => {
    A.current = !1;
  }, [F, f]), o.useMemo(() => a ? {
    reference: {
      onKeyDown: H,
      [St[b]]: (v) => {
        u && n(!1, v.nativeEvent, "reference-press");
      }
    },
    floating: {
      onKeyDown: H,
      onMouseDown() {
        L.current = !0;
      },
      onMouseUp() {
        L.current = !0;
      },
      [Dt[f]]: () => {
        A.current = !0;
      }
    }
  } : {}, [a, u, f, b, n, H]);
}
let Ce;
process.env.NODE_ENV !== "production" && (Ce = /* @__PURE__ */ new Set());
function Zt(e) {
  var r;
  e === void 0 && (e = {});
  const {
    open: t = !1,
    onOpenChange: n,
    nodeId: l
  } = e;
  if (process.env.NODE_ENV !== "production") {
    var s;
    const C = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if ((s = e.elements) != null && s.reference && !Y(e.elements.reference)) {
      var c;
      if (!((c = Ce) != null && c.has(C))) {
        var i;
        (i = Ce) == null || i.add(C), console.error(C);
      }
    }
  }
  const [m, a] = o.useState(null), E = ((r = e.elements) == null ? void 0 : r.reference) || m, g = it(e), f = ve(), u = ke() != null, b = te((C, I, y) => {
    C && (D.current.openEvent = I), R.emit("openchange", {
      open: C,
      event: I,
      reason: y,
      nested: u
    }), n == null || n(C, I, y);
  }), h = o.useRef(null), D = o.useRef({}), R = o.useState(() => Rt())[0], p = le(), W = o.useCallback((C) => {
    const I = Y(C) ? {
      getBoundingClientRect: () => C.getBoundingClientRect(),
      contextElement: C
    } : C;
    g.refs.setReference(I);
  }, [g.refs]), F = o.useCallback((C) => {
    (Y(C) || C === null) && (h.current = C, a(C)), (Y(g.refs.reference.current) || g.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    C !== null && !Y(C)) && g.refs.setReference(C);
  }, [g.refs]), A = o.useMemo(() => ({
    ...g.refs,
    setReference: F,
    setPositionReference: W,
    domReference: h
  }), [g.refs, F, W]), L = o.useMemo(() => ({
    ...g.elements,
    domReference: E
  }), [g.elements, E]), K = o.useMemo(() => ({
    ...g,
    refs: A,
    elements: L,
    dataRef: D,
    nodeId: l,
    floatingId: p,
    events: R,
    open: t,
    onOpenChange: b
  }), [g, l, p, R, t, b, A, L]);
  return $(() => {
    const C = f == null ? void 0 : f.nodesRef.current.find((I) => I.id === l);
    C && (C.context = K);
  }), o.useMemo(() => ({
    ...g,
    context: K,
    refs: A,
    elements: L
  }), [g, A, L, K]);
}
function zt(e, r) {
  r === void 0 && (r = {});
  const {
    open: t,
    onOpenChange: n,
    events: l,
    refs: s,
    elements: {
      domReference: c
    }
  } = e, {
    enabled: i = !0,
    visibleOnly: m = !0
  } = r, a = o.useRef(!1), E = o.useRef(), g = o.useRef(!0);
  return o.useEffect(() => {
    if (!i)
      return;
    const f = dt(c);
    function u() {
      !t && ce(c) && c === G(U(c)) && (a.current = !0);
    }
    function b() {
      g.current = !0;
    }
    return f.addEventListener("blur", u), f.addEventListener("keydown", b, !0), () => {
      f.removeEventListener("blur", u), f.removeEventListener("keydown", b, !0);
    };
  }, [c, t, i]), o.useEffect(() => {
    if (!i)
      return;
    function f(u) {
      let {
        reason: b
      } = u;
      (b === "reference-press" || b === "escape-key") && (a.current = !0);
    }
    return l.on("openchange", f), () => {
      l.off("openchange", f);
    };
  }, [l, i]), o.useEffect(() => () => {
    clearTimeout(E.current);
  }, []), o.useMemo(() => i ? {
    reference: {
      onPointerDown(f) {
        qe(f.nativeEvent) || (g.current = !1);
      },
      onMouseLeave() {
        a.current = !1;
      },
      onFocus(f) {
        if (a.current)
          return;
        const u = z(f.nativeEvent);
        if (m && Y(u))
          try {
            if (Xe() && ct())
              throw Error();
            if (!u.matches(":focus-visible"))
              return;
          } catch {
            if (!g.current && !Ye(u))
              return;
          }
        n(!0, f.nativeEvent, "focus");
      },
      onBlur(f) {
        a.current = !1;
        const u = f.relatedTarget, b = Y(u) && u.hasAttribute(J("focus-guard")) && u.getAttribute("data-type") === "outside";
        E.current = window.setTimeout(() => {
          const h = G(c ? c.ownerDocument : document);
          !u && h === c || X(s.floating.current, h) || X(c, h) || b || n(!1, f.nativeEvent, "focus");
        });
      }
    }
  } : {}, [i, m, c, s, n]);
}
const Ve = "active", Be = "selected";
function Te(e, r, t) {
  const n = /* @__PURE__ */ new Map(), l = t === "item";
  let s = e;
  if (l && e) {
    const {
      [Ve]: c,
      [Be]: i,
      ...m
    } = e;
    s = m;
  }
  return {
    ...t === "floating" && {
      tabIndex: -1
    },
    ...s,
    ...r.map((c) => {
      const i = c ? c[t] : null;
      return typeof i == "function" ? e ? i(e) : null : i;
    }).concat(e).reduce((c, i) => (i && Object.entries(i).forEach((m) => {
      let [a, E] = m;
      if (!(l && [Ve, Be].includes(a)))
        if (a.indexOf("on") === 0) {
          if (n.has(a) || n.set(a, []), typeof E == "function") {
            var g;
            (g = n.get(a)) == null || g.push(E), c[a] = function() {
              for (var f, u = arguments.length, b = new Array(u), h = 0; h < u; h++)
                b[h] = arguments[h];
              return (f = n.get(a)) == null ? void 0 : f.map((D) => D(...b)).find((D) => D !== void 0);
            };
          }
        } else
          c[a] = E;
    }), c), {})
  };
}
function Jt(e) {
  e === void 0 && (e = []);
  const r = e, t = o.useCallback((s) => Te(s, e, "reference"), r), n = o.useCallback((s) => Te(s, e, "floating"), r), l = o.useCallback(
    (s) => Te(s, e, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    e.map((s) => s == null ? void 0 : s.item)
  );
  return o.useMemo(() => ({
    getReferenceProps: t,
    getFloatingProps: n,
    getItemProps: l
  }), [t, n, l]);
}
const At = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function en(e, r) {
  var t;
  r === void 0 && (r = {});
  const {
    open: n,
    floatingId: l
  } = e, {
    enabled: s = !0,
    role: c = "dialog"
  } = r, i = (t = At.get(c)) != null ? t : c, m = le(), E = ke() != null;
  return o.useMemo(() => {
    if (!s)
      return {};
    const g = {
      id: l,
      ...i && {
        role: i
      }
    };
    return i === "tooltip" || c === "label" ? {
      reference: {
        ["aria-" + (c === "label" ? "labelledby" : "describedby")]: n ? l : void 0
      },
      floating: g
    } : {
      reference: {
        "aria-expanded": n ? "true" : "false",
        "aria-haspopup": i === "alertdialog" ? "dialog" : i,
        "aria-controls": n ? l : void 0,
        ...i === "listbox" && {
          role: "combobox"
        },
        ...i === "menu" && {
          id: m
        },
        ...i === "menu" && E && {
          role: "menuitem"
        },
        ...c === "select" && {
          "aria-autocomplete": "none"
        },
        ...c === "combobox" && {
          "aria-autocomplete": "list"
        }
      },
      floating: {
        ...g,
        ...i === "menu" && {
          "aria-labelledby": m
        }
      },
      item(f) {
        let {
          active: u,
          selected: b
        } = f;
        const h = {
          role: "option",
          ...u && {
            id: l + "-option"
          }
        };
        switch (c) {
          case "select":
            return {
              ...h,
              "aria-selected": u && b
            };
          case "combobox":
            return {
              ...h,
              ...u && {
                "aria-selected": !0
              }
            };
        }
        return {};
      }
    };
  }, [s, c, i, n, l, m, E]);
}
export {
  Xt as FloatingArrow,
  $t as FloatingFocusManager,
  jt as FloatingOverlay,
  Ut as FloatingPortal,
  rn as arrow,
  sn as autoUpdate,
  un as computePosition,
  cn as flip,
  Ee as getOverflowAncestors,
  ln as inline,
  vt as platform,
  an as shift,
  fn as size,
  Gt as useClick,
  Qt as useDismiss,
  Zt as useFloating,
  ke as useFloatingParentNodeId,
  Lt as useFloatingPortalNode,
  ve as useFloatingTree,
  zt as useFocus,
  Yt as useHover,
  le as useId,
  Jt as useInteractions,
  qt as useMergeRefs,
  en as useRole
};
